import { LabeledRadio } from "@cirrus/ui-kit/src/components/atoms/labeled-radio/index.js"

// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"

import { RadioGroup, styled } from "@mui/material"
import React from "react"
import { Field } from "react-final-form"

interface IRadioGroupFilterProps {
  label: string,
  name: string,
  options: IRadioGroupOption[]
}

export interface IRadioGroupOption {
  label: string;
  value: any;
}

const StyledRadioGroup = styled(RadioGroup)({
  marginLeft: "12px"
})

const Label = styled("div")({
  fontSize: "14px",
  marginBottom: "6px"
})

export const RadioGroupFilter = (props: IRadioGroupFilterProps) => {

  return (
    <Field name={props.name}>
      {(field) => (
        <div>
          <Label>{props.label}</Label>
          <StyledRadioGroup {...field} aria-label="color" name="color" row>
            {props.options.map((option) => (
              <LabeledRadio
                {...field}
                {...option}
                label={i18n(option.label)}
                key={option.value}
                color="primary"
                checked={field.input.value === option.value}
                onChange={() => field.input.onChange(option.value)}
              />
            ))}
          </StyledRadioGroup>
        </div>
      )}
    </Field>
  )
}
